module.exports = __webpack_public_path__ + "img/selectExist.a065089e.svg";